import { render, staticRenderFns } from "./ProyectDetails.vue?vue&type=template&id=840d6ede&"
import script from "./ProyectDetails.vue?vue&type=script&lang=js&"
export * from "./ProyectDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProyectDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports